import chroma from 'chroma-js'

const palettes = {
  // 语义色
  // primary: chroma('#0080D6').rgb().join(','),
  // error: chroma('#EF4444').rgb().join(','),
  // success: chroma('#1ee0ac').rgb().join(','),

  primary: chroma('#0152D9').rgb().join(','),
  secondary: chroma('#94A4B8').rgb().join(','),
  link: chroma('#0080D6').rgb().join(','),
  info: chroma('#0080D6').rgb().join(','),
  error: chroma('#E34D59').rgb().join(','),
  success: chroma('#00A870').rgb().join(','),
  warning: chroma('#ED7B2F').rgb().join(','),

  // 背景色变量 可以通过 ow-bg-xxx-color 的类名使用
  // bgComps: '#F3F4F6',
  // bgBody: '#F3F4F6',
  // bgTextSelection: '#0080D6',
  // bgDarkMap: '#122032e6',
  bgComps: chroma('#F3F4F6').rgb().join(','),
  bgBody: chroma('#F3F4F6').rgb().join(','),
  bgTextSelection: chroma('#0080D6').rgb().join(','),
  bgDarkMap: chroma('#122032e6').rgb().join(','),
  bgActive: chroma('#f2f7ff').rgb().join(','),

  // 文本色变量
  // text: '#444444',
  // textSecondary: '#6F6F6F',
  // textHeading: '#444444',
  // textInverse: '#FFFFFF',
  // textDark: '#3f4d60',
  text: chroma('#444444').rgb().join(','),
  textSecondary: chroma('#6F6F6F').rgb().join(','),
  textHeading: chroma('#444444').rgb().join(','),
  textInverse: chroma('#FFFFFF').rgb().join(','),
  textDark: chroma('#3f4d60').rgb().join(','),

  // 这是你要新增的其他颜色的变量
  // border: '#dbdfea', // 边框色，用她的组件边框色
  border: chroma('#dbdfea').rgb().join(','), // 边框色，用她的组件边框色
  borderSecondary: chroma('#AFBAC9').rgb().join(','), // 第二种边框色
}

const palettesDark = {
  // 背景色变量 可以通过 ow-bg-xxx-color 的类名使用
  bgMap: '#122032e6',
  // 文本色变量，相当于text-gray-700,需要用在css中所以单独取色定义了变量
  textDark: '#3f4d60',
}

export default {
  colors: {},
  palettes,
  palettesDark,
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
    extrablack: 950,
  },
  fontSizes: {
    '2xs': 10,
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
    '4xl': 36,
    '5xl': 48,
    '6xl': 60,
    '7xl': 72,
    '8xl': 96,
    '9xl': 128,
  },
  // 新加
  // 容器背景颜色
  box: {
    background: '#fff',
    borderRadius: '4px',
  },
  button: {
    borderRadius: '4px',
  },

  // 默认圆角
  defaultBorderRadius: '4px',

  // 统一boxShadow
  // boxShadow: `0 3px 6px -4px ${chroma(palettes.primary).alpha(
  //   0.2
  // )}, 0 6px 16px 0 ${chroma(palettes.primary).alpha(0.2)}`,
  // shadow: {
  //   primary: chroma(palettes.primary).alpha(0.1),
  //   // primary: chroma('#0080D6').rgb().join(' '),
  // },
  boxShadow: `0 3px 6px -4px rgba(var(--ow-primary-color), .20), 0 6px 16px 0 rgb(var(--primary-color) .20)`,
  shadow: {
    primary: 'rgba(var(--ow-primary-color),.10)',
    // primary: chroma('#0080D6').rgb().join(' '),
  },
}
